import { createContext, useContext } from "react"

/**
 * Shared dark mode state and actions exposed by the DarkModeProvider.
 */
export interface DarkModeContextType {
  isDarkMode: boolean
  toggleDarkMode: () => void
}

/**
 * React context used to share dark mode preferences throughout the app.
 */
export const DarkModeContext = createContext<DarkModeContextType | undefined>(undefined)

/**
 * Hook for consuming the DarkModeContext with a runtime safety check.
 *
 * @throws Error if called outside of a DarkModeProvider.
 * @returns The current dark mode context value.
 */
export const useDarkMode = () => {
  const context = useContext(DarkModeContext)
  if (context === undefined) {
    throw new Error("useDarkMode must be used within a DarkModeProvider")
  }
  return context
}
